import { useState } from "react";

const TermsConditionModal = () => {
  const [open, setOpen] = useState(false);
  const [termsText, setTermsText] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleAccept = () => {
    handleClose();
  };

  return (
    <>
      <span
        onClick={handleOpen}
        className="text-decoration-underline text-primary cursor-pointer"
      >
        Terms & Condition
      </span>

      {open && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content border-0 shadow-lg">
              {/* Header */}
              <div className="modal-header border-bottom-0 pb-0">
                <h5 className="modal-title fw-bold text-dark">
                  Terms & Conditions
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                ></button>
              </div>

              {/* Body */}
              <div
                className="modal-body pt-2"
                style={{ maxHeight: "400px", overflowY: "auto" }}
              >
                {termsText ? (
                  <p className="text-muted" style={{ whiteSpace: "pre-line" }}>
                    {termsText}
                  </p>
                ) : (
                  <p className="text-muted">
                    No Terms & Conditions have been added yet.
                  </p>
                )}
              </div>

              <div className="modal-footer border-top-0 pt-0">
                <button
                  type="button"
                  className="btn btn-secondary px-4"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TermsConditionModal;
